import { Injectable, inject } from '@angular/core';
import {UserService} from '..';
import {UserRoles} from '../../enums';
import {NavElement} from '@bvgo-ict/vwui-angular';

@Injectable({
    providedIn: 'root'
})
export class MenuBuilder {
    private userService = inject(UserService);

    public async buildProjectsMenu(): Promise<NavElement[]> {
        if (await this.userService.userHasAnyRole([
            UserRoles.PIT_USER
        ])) {
            return [
                {
                    type: 'item',
                    label: 'MENU.labels.projects',
                    iconName: 'vwui-folder',
                    href: 'projecten'
                },
                {
                    type: 'item',
                    label: 'MENU.labels.projects_all',
                    iconName: 'vwui-folder',
                    href: 'projecten_all'
                }
            ];
        } else {
            return [];
        }
    }
}
